import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import CollectionSessionInfoForm from './CollectionSessionInfoForm';
import ScaleVerificationTable from './ScaleVerificationTable';
import { useEffect, useState } from 'react';
import SubmitScaleVerificationForm from './SubmitScaleVerification';
import dayjs from 'dayjs';
import { useForm } from 'antd/es/form/Form';
import '../ViewInspectionData.scss';

interface IViewRecordedPricesModal {
  isModalOpen: boolean;
  onCancel: () => void;
  formData: any;
}

type RowState = {
  repeatability?: number;
  ascending?: string;
  descending?: string;
};

const ViewRecordedMonitoringVisitModal = (props: IViewRecordedPricesModal) => {
  const { t } = useTranslation(['inspection']);
  const { isModalOpen, onCancel, formData } = props;
  const [form] = useForm();

  const [tableRecords, setTableRecords] = useState<Record<number, RowState>>({});

  const prepRecordedData = (inspectionData: any) => {
    const inspectionWithDayjsDate = {
      ...inspectionData,
      date: dayjs(inspectionData.date),
    };
    form.setFieldsValue(inspectionWithDayjsDate);
  };

  useEffect(() => {
    if (!isModalOpen) {
      form.resetFields();
      return;
    }
    prepRecordedData(formData);

    const tableData = form.getFieldValue('verificationTableData');
    setTableRecords(tableData);
  }, [isModalOpen, form]);

  return (
    <Modal
      closable={{ 'aria-label': 'Custom Close Button' }}
      open={isModalOpen}
      onCancel={onCancel}
      footer={null}
      width={'80%'}
      centered
    >
      <div className="view-mode-form mt-6 flex max-h-[75vh] w-full flex-col overflow-y-auto p-2 md:mt-4">
        <div className="flex w-full justify-center">
          <div className="mt-4 text-center">
            <h1 className="mb-2 text-2xl font-bold">{t('scaleFormatMainHeading')}</h1>
            <p>{t('scaleFormatSubHeading')}</p>
          </div>
        </div>

        <CollectionSessionInfoForm
          isViewMode={true}
          form={form}
          isModal={false}
          triggeredFromTask={false}
          taskData={{}}
          handleNext={() => {}}
          handleCancel={() => {}}
        />

        <ScaleVerificationTable
          initialValues={tableRecords}
          isViewMode={true}
          handleCancel={() => {}}
        />
        <span className="p-2"></span>
        <SubmitScaleVerificationForm form={form} disabled={true} isViewMode={true} />
      </div>
    </Modal>
  );
};

export default ViewRecordedMonitoringVisitModal;
